import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

import titlepre from '../../assest/image/Vector.svg';
import renderStars from '../../utilities/renderProductStars';
import { apiGET, apiPOST, apiPUT } from '../../utilities/apiHelpers';
import { setCartCount } from '../../redux/users/users';
import { API_URL } from '../../config';

const KindelyMedicineBrand = ({
  item,
  globalConfig,
  stepperProgressCartData,
  setStepperProgressCartData,
  refreshProducts,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = useSelector((state) => state.user?.userData?.id);

  const [loading, setLoading] = useState(false);
  // 1. ADD LOCAL STOCK STATE to show changes instantly
  const [localAvailableQty, setLocalAvailableQty] = useState(item?.availableQuantity);

  // Sync local stock if the prop changes from elsewhere
  useEffect(() => {
    setLocalAvailableQty(item?.availableQuantity);
  }, [item?.availableQuantity]);

  const cartItem = stepperProgressCartData?.cartData?.find(
    (c) => c.productDetails?._id === item?._id
  );

  const cartQty = cartItem?.quantity || 0;
  const cartId = cartItem?._id;

  /* ================= FULL DATA SYNC ================= */
  // const triggerFullDataRefresh = async () => {
  //   try {
  //     // Manual delay for the 2-second loading effect
  //     await new Promise(resolve => setTimeout(resolve, 1000));

  //     // A. Update Cart
  //     const res = await apiGET(`/v1/stepper-progress/user-stepper-progress/${userId}`);
  //     if (res?.data?.status) {
  //       setStepperProgressCartData(res?.data?.data || {});
  //       dispatch(setCartCount(res?.data?.data?.cartData?.length || 0));
  //     }

  //     // B. DIRECT PRODUCT REFRESH
  //     // We hit the API and look for THIS specific product in the response
  //     const productRes = await apiGET(`${API_URL}/v1/product/getAllProductstwo`);

  //     if (productRes?.data?.status) {
  //       const products = productRes?.data?.data?.product || [];
  //       const updatedItem = products.find(p => p._id === item._id);
  //       if (updatedItem) {
  //         setLocalAvailableQty(updatedItem.availableQuantity); // Update display
  //       }
  //       // Also trigger parent refresh if provided
  //       if (refreshProducts) await refreshProducts();
  //     }
  //   } catch (error) {
  //     console.error("Refresh Error:", error);
  //   }
  // };
 
  const triggerFullDataRefresh = async () => {
    try {
      // A. Update Cart
      const res = await apiGET(`/v1/stepper-progress/user-stepper-progress/${userId}`);
      if (res?.data?.status) {
        setStepperProgressCartData(res?.data?.data || {});
        dispatch(setCartCount(res?.data?.data?.cartData?.length || 0));
      }

      // B. Get THIS product's stock ONLY
      const productRes = await apiGET(`${API_URL}/v1/product/stock/${item._id}`);
      if (productRes?.data?.status && productRes?.data?.data) {
        setLocalAvailableQty(productRes.data.data.availableStock); // Update local stock
      }

      // Optional: trigger parent refresh
      if (refreshProducts) await refreshProducts();
    } catch (error) {
      console.error("Refresh Error:", error);
    }
  };

  const handleIncrement = async (e) => {
    e.stopPropagation();
    if (localAvailableQty <= 0) return toast.error("No more stock");

    setLoading(true);
    try {
      const response = await apiPUT(`/v1/cart/update/${cartId}`, { quantity: cartQty + 1 });
      if (response.status) {
        await triggerFullDataRefresh(); // Hit APIs and update UI
      }
    } catch (err) {
      toast.error("Update failed");
    } finally {
      setLoading(false);
    }
  };

  const handleDecrement = async (e) => {
    e.stopPropagation();
    if (cartQty <= 1) return;

    setLoading(true);
    try {
      const response = await apiPUT(`/v1/cart/update/${cartId}`, { quantity: cartQty - 1 });
      if (response.status) {
        await triggerFullDataRefresh();
      }
    } catch (err) {
      toast.error("Update failed");
    } finally {
      setLoading(false);
    }
  };

    const addToCart = async (e) => {
      e.stopPropagation();
      if (!userId) return toast.error("Please login first");
  
      setLoading(true);
      try {
        const response = await apiPOST(`/v1/cart/add`, {
          productId: item._id,
          userId,
          quantity: 1
        });
  
        if (response.status) {
          // Use 'userId' here, not 'isLoggedIn' (which is a boolean)
          const stepperResponse = await apiGET(`/v1/stepper-progress/user-stepper-progress/${userId}`);
  
          // Check if stepper doesn't exist (400) or is missing
          if (stepperResponse?.data?.code === 400 || !stepperResponse?.data?.status) {
            const stepperProgressAddPayload = { orderMode: 'order' };
  
            // Use 'userId' here as well
            const userStepperAddResponse = await apiPOST(
              `${API_URL}/v1/stepper-progress/add-stepper-progress/${userId}`,
              stepperProgressAddPayload
            );
  
            if (userStepperAddResponse.data?.status) {
              setStepperProgressCartData(userStepperAddResponse.data?.data);
              dispatch(setCartCount(userStepperAddResponse.data?.data?.cartData?.length || 0));
              toast.success("Product added to cart");
            }
          } else {
            setStepperProgressCartData(stepperResponse.data?.data);
            dispatch(setCartCount(stepperResponse.data?.data?.cartData?.length || 0));
            toast.success("Product added to cart");
          }
  
          toast.error(stepperResponse.data?.message);
          // Optional: Refresh product list to update stock numbers immediately
          await triggerFullDataRefresh();
        }
      } catch (err) {
        console.error("Add to cart error:", err);
        toast.error("Failed to add");
      } finally {
        setLoading(false);
      }
    };

  return (
    <div className="p-4 border rounded-[16px] relative bg-white">
      {/* Background stays visible but blurred */}
      {loading && (
        <div className="absolute inset-0 bg-white/60 backdrop-blur-[1px] flex flex-col items-center justify-center z-10 rounded-[16px]">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#14967F]" />
          <p className="text-[10px] text-[#14967F] font-bold mt-2">Updating Stock...</p>
        </div>
      )}

      <div className="cursor-pointer" onClick={() => navigate(`/product/${item?._id}`)}>
        {/* Always render this container to maintain height (h-5) */}
        <div className="h-5 mb-2 flex items-center">
          {item?.isPrescription ? (
            <div className="flex items-center text-[10px] text-gray-600">
              <img src={titlepre} alt="pre" className="mr-1 w-3 h-3" />
              Prescription Required
            </div>
          ) : (
            /* No text rendered here, but the parent div keeps the margin/height */
            null
          )}
        </div>
        <img src={item?.bannerImg} alt={item?.name} className="w-full h-32 object-cover rounded-md" />
        <h3 className="mt-2 font-bold text-sm truncate">{item?.name}</h3>
        <div className="flex gap-1 mt-1">{renderStars(item?.avgRating)}</div>
        <div className="flex justify-between items-center mt-2">
          <div className='flex gap-2'>
            <span className="text-[#095D7E] font-semibold">₹{globalConfig?.currencyData?.symbol}{item.discountedPrice}</span>
            <span className="line-through text-gray-500">₹{globalConfig?.currencyData?.symbol}{item.price}</span>
          </div>
          {/* USES LOCAL STATE FOR REAL-TIME UPDATE */}
          <span className="bg-yellow-100 text-yellow-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-full dark:bg-yellow-900 dark:text-yellow-300">
            {Math.max(0, localAvailableQty)} left
          </span>
        </div>
      </div>

      <div className="mt-4">
        {localAvailableQty > 0 ? (
          cartItem ? (
            <div className="flex justify-between items-center bg-gray-200 rounded-full h-10 overflow-hidden">
              {/* <button onClick={handleDecrement} className="w-12 h-full bg-[#14967F] text-white">−</button> */}
              <button
                className="bg-[#14967F] text-white rounded-full w-[58px] h-full py-2 flex items-center justify-center"
                onClick={handleDecrement}
              > - </button>
              <span className="font-bold text-[#14967F]">{cartQty}</span>
              {/* <button onClick={handleIncrement} className="w-12 h-full bg-[#14967F] text-white">+</button> */}
              <button
                className="bg-[#14967F] text-white rounded-full w-[58px] h-full py-2 flex items-center justify-center"
                onClick={handleIncrement}
              > + </button>
            </div>
          ) : (
            <button onClick={addToCart} className="group w-full flex items-center justify-center gap-2 bg-gray-200 text-[#14967F] hover:bg-[#14967F] hover:text-white font-bold py-[10px] rounded-full text-xs mb-2 transition-all duration-200 active:scale-95"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="16"
                viewBox="0 0 23 19"
                fill="none"
                className="shrink-0"
              >
                {/* Use stroke="currentColor" and fill="currentColor" so they inherit the text color */}
                <path
                  d="M4.25 3.76075H21.75L19.5296 12.1156C19.3623 12.7445 19.0091 13.2977 18.5233 13.6916C18.0376 14.0854 17.4458 14.2984 16.8374 14.2984H7.4574C6.76785 14.2988 6.1024 14.0256 5.58857 13.5312C5.07473 13.0367 4.74865 12.3558 4.6728 11.6188L3.55 0.75H0.75"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.99257 18.9129C7.75864 18.9129 8.37966 18.2918 8.37966 17.5258C8.37966 16.7597 7.75864 16.1387 6.99257 16.1387C6.22649 16.1387 5.60547 16.7597 5.60547 17.5258C5.60547 18.2918 6.22649 18.9129 6.99257 18.9129Z"
                  fill="currentColor"
                />
                <path
                  d="M18.0902 18.9129C18.8563 18.9129 19.4773 18.2918 19.4773 17.5258C19.4773 16.7597 18.8563 16.1387 18.0902 16.1387C17.3241 16.1387 16.7031 16.7597 16.7031 17.5258C16.7031 18.2918 17.3241 18.9129 18.0902 18.9129Z"
                  fill="currentColor"
                />
                <path
                  d="M12.266 12.2664C11.9486 12.2664 11.6912 12.009 11.6912 11.6916V6.06697C11.6912 5.74953 11.9486 5.49219 12.266 5.49219C12.5834 5.49219 12.8408 5.74953 12.8408 6.06697V11.6916C12.8408 12.009 12.5834 12.2664 12.266 12.2664ZM9.45369 9.45406C9.13624 9.45406 8.87891 9.19673 8.87891 8.87928C8.87891 8.56184 9.13624 8.3045 9.45369 8.3045H15.0783C15.3958 8.3045 15.6531 8.56184 15.6531 8.87928C15.6531 9.19673 15.3958 9.45406 15.0783 9.45406H9.45369Z"
                  fill="currentColor"
                />
              </svg>
              <span>Add to cart</span>
            </button>
          )
        ) : (
          <div className="text-center bg-red-100 text-red-700 py-2 rounded-full text-xs font-bold mb-2">Out of stock</div>
        )}
      </div>
    </div>
  );
};

export default KindelyMedicineBrand;